import React from 'react';

import { observer } from 'mobx-react';
import { reverse } from 'named-urls';

import ActionCell, { ActionConfig } from 'components/Grid/components/ActionCell';
import routes from 'core/routes';
import { EntityModules } from 'core/constants';
import { useStore } from 'utils/hooks/store';
import API from 'utils/api/api';

interface Props {
  rowData: { uuid: string; name?: string };
}

const EventFormsActionCell: React.FC<Props> = ({ rowData }) => {
  const { routing, notification } = useStore();

  const handleEdit = (): void => {
    const path = reverse(routes.dashboard.settings.objects.details.formBuilder.toString(), {
      moduleName: EntityModules.Events,
    });
    routing.push(`${path + rowData.uuid}/`);
  };

  const handleDuplicate = async (): Promise<void> => {
    try {
      const {
        data: { uuid: duplicatedUuid },
      } = await API.entities.duplicateEntityForm(EntityModules.Events, rowData.uuid)();
      const path = reverse(routes.dashboard.settings.objects.details.formBuilder.toString(), {
        moduleName: EntityModules.Events,
      });
      routing.push(`${path + duplicatedUuid}/`);
      notification.enqueueSuccessSnackbar('Form duplicated successfully');
    } catch (error) {
      notification.enqueueErrorSnackbar('Failed to duplicate form');
    }
  };

  const actions: ActionConfig[] = [
    {
      id: 'edit-button',
      label: 'Edit',
      onClick: handleEdit,
    },
    {
      id: 'duplicate-button',
      label: 'Duplicate',
      onClick: handleDuplicate,
    },
  ];

  return <ActionCell actions={actions} recordName={rowData.name} />;
};

export default observer(EventFormsActionCell);
